<div class="flex-column h-100">
  <odx-content-box>
    <div odxLayout="flex">
      <h6 class="odx-title-6 header-prefix" i18n="@@transmitterConfiguration.selectTransmitter.headerPrefix">Transmitter für</h6>
      <app-configuration-wizard-header class="product-header" [data]="selectedGas" [showCosts]="showCosts">
      </app-configuration-wizard-header>
    </div>
  </odx-content-box>

  <div class="configuration-wizard-header flex-column space-top">
    <h5
      class="odx-title-5"
      i18n="@@transmitterConfiguration.selectTransmitter.header"
      data-testid="transmitterConfiguration.selectTransmitter.header"
    >
      Transmitter auswählen
    </h5>

    <div odxLayout="flex vertical-center" class="filters">
      <app-filter-product (searchEvent)="search($event)"></app-filter-product>
    </div>

    <div odxlayout="flex vertical-center">
      <odx-form-field
        i18n-label="@@editTransmitterForm.label.radius"
        label="Radius Überwachungsbereich (Meter)"
        id="detection-radius"
      >
        <input
          type="number"
          min="0"
          odxFormFieldControl
          [value]="defaultDetectionRangeValue"
          (input)="onDefaultDetectionRangeInput($any($event.target).value)"
          i18n-placeholder="@@transmitterConfiguration.defaultDetectionRange.placeholder"
          placeholder="2.5"
          #detectionRadius
        />
      </odx-form-field>
      <odx-icon
        name="info"
        [odxTooltip]="defaultDetectionRangeInfoText"
        odxTooltipSize="medium"
        [odxTooltipOptions]="{ position: 'bottom' }"
      />
    </div>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    <form [formGroup]="selectedTransmitterForm" class="overflow-hidden h-100">
      <odx-radio-group formControlName="selectedTransmitter" required="true" class="overflow-hidden h-100">
        <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
          @if (filteredSelectableProducts.length > 0) {
            @for (product of filteredSelectableProducts; track product) {
              <app-transmitter-card
                class="overflow-hidden"
                [transmitterData]="product"
                [showCosts]="showCosts"
                [isSelected]="selectedTransmitter?.id === product.id"
                (click)="select(product)"
                (transmitterSelected)="select(product)"
                >{{ product | localizeProductName }}</app-transmitter-card
              >
            }
          } @else {
            <app-refresh-products-hint dataType="Transmitter" i18n-dataType="@@global.transmitters"></app-refresh-products-hint>
          }
        </div>
      </odx-radio-group>
    </form>
  </odx-content-box>
</div>
